import React, { useEffect, useRef, useState, useMemo } from "react";
import "../css/TextType.css";

const TextType = ({
  text = ["Hello World!", "Welcome to my portfolio."],
  typingSpeed = 100,
  deletingSpeed = 50,
  pauseDuration = 2000,
  loop = true,
  className = "",
  showCursor = true,
  cursorCharacter = "|",
  textColors = [],
}) => {
  const [displayedText, setDisplayedText] = useState("");
  const [isDeleting, setIsDeleting] = useState(false);
  const [currentTextIndex, setCurrentTextIndex] = useState(0);
  const [charIndex, setCharIndex] = useState(0);
  const cursorRef = useRef(null);

  const textArray = useMemo(() => {
    return Array.isArray(text) ? text : [text];
  }, [text]);

  const currentColor =
    textColors.length > 0
      ? textColors[currentTextIndex % textColors.length]
      : "#fff";

  useEffect(() => {
    const currentText = textArray[currentTextIndex];
    let timeout;

    if (isDeleting) {
      if (charIndex > 0) {
        timeout = setTimeout(() => {
          setDisplayedText((prev) => prev.slice(0, -1));
          setCharIndex((prev) => prev - 1);
        }, deletingSpeed);
      } else {
        setIsDeleting(false);
        setCurrentTextIndex((prev) => (prev + 1) % textArray.length);
      }
    } else {
      if (charIndex < currentText.length) {
        timeout = setTimeout(() => {
          setDisplayedText((prev) => prev + currentText[charIndex]);
          setCharIndex((prev) => prev + 1);
        }, typingSpeed);
      } else if (loop) {
        timeout = setTimeout(() => {
          setIsDeleting(true);
        }, pauseDuration);
      }
    }

    return () => clearTimeout(timeout);
  }, [
    charIndex,
    isDeleting,
    currentTextIndex,
    deletingSpeed,
    loop,
    pauseDuration,
    textArray,
    typingSpeed,
  ]);

  return (
    <div className={`text-type-container ${className}`}>
      <span className="text-type__content" style={{ color: currentColor }}>
        {displayedText}
        {showCursor && (
          <span ref={cursorRef} className="text-type__cursor">
            {cursorCharacter}
          </span>
        )}
      </span>
    </div>
  );
};

export default TextType;
